// Newsletter signups go straight to Kit's form endpoint. We don't load Kit's
// embed script: third-party code running on the site could reach the admin's
// GitHub sign-in on /admin, and the plain form endpoint is all we need.

export const kitFormAction = (formId?: string) =>
  formId && /^\d{1,12}$/.test(formId.trim()) ? `https://app.kit.com/forms/${formId.trim()}/subscriptions` : undefined;

export type SubscribeResult = { kind: 'success' } | { kind: 'verify'; url: string } | { kind: 'error'; message: string };

type FetchLike = (input: string, init?: RequestInit) => Promise<Response>;

export async function subscribe(formId: string | undefined, email: string, fetchImpl: FetchLike = (i, init) => fetch(i, init)): Promise<SubscribeResult> {
  const action = kitFormAction(formId);
  if (!action) return { kind: 'error', message: "This signup form isn't set up yet." };

  const body = new FormData();
  body.append('email_address', email.trim());

  let response: Response;
  try {
    response = await fetchImpl(action, { method: 'POST', headers: { Accept: 'application/json' }, body });
  } catch {
    return { kind: 'error', message: "Couldn't reach the mailing list. Check your connection and try again." };
  }

  let json: { status?: string; url?: string; errors?: { messages?: unknown[] } } | undefined;
  try {
    json = await response.json();
  } catch {
    json = undefined;
  }

  if (response.ok && json?.status === 'success') return { kind: 'success' };
  // Kit sometimes asks for an extra human check before accepting the signup.
  if (response.ok && json?.status === 'quarantined' && typeof json.url === 'string' && /^https:\/\//.test(json.url)) {
    return { kind: 'verify', url: json.url };
  }
  const message = json?.errors?.messages?.find((m): m is string => typeof m === 'string');
  return { kind: 'error', message: message || 'Something went wrong. Please try again.' };
}
